import * as React from 'react';
import Grid from '@mui/material/Grid2';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import Copyright from '../internals/components/Copyright';
import ChartFleetsByType from '../components/ChartFleetsByType';
import CustomizedTreeView from '../components/CustomizedTreeView';
import FleetsDataGrid from '../components/FleetsDataGrid';
import HighlightedCard from '../components/HighlightedCard';
import PageViewsBarChart from '../components/PageViewsBarChart';
import SessionsChart from '../components/SessionsChart';
import StatCard from '../components/StatCard';

const data = [
  {
    title: 'MSR',
    value: '40',
    interval: 'Last 30 days',
    data: [0, 3, 6, 9, 12, 10, 8, 11, 14, 12, 15, 20, 17, 19, 16, 18, 21, 24, 22, 25, 23, 20, 22, 24, 21, 23, 25, 35, 39, 40]
    ,
  },
  {
    title: 'C3 ',
    value: '0',
    interval: 'Last 30 days',
    data: Array(30).fill(0),
  },
  {
    title: 'Kangaroo',
    value: '0',
    interval: 'Last 30 days',
    data: Array(30).fill(0),
  },
  {
    title: 'MSR #2',
    value: '0',
    interval: 'Last 30 days',
    data: Array(30).fill(0)
    ,
  },
  {
    title: 'C3 #2',
    value: '0',
    interval: 'Last 30 days',
    data: Array(30).fill(0),
  },
  {
    title: 'Retrofit',
    value: '0',
    interval: 'Last 30 days',
    data: Array(30).fill(0),
  },
];

export default function Fleets() {
  return (
    <Box sx={{ width: '100%', maxWidth: { sm: '100%', md: '1700px' } }}>
      {/* cards */}
      <Typography component="h2" variant="h6" sx={{ mb: 2 }}>
        Overview
      </Typography>
      <Grid
        container
        spacing={2}
        columns={12}
        sx={{ mb: (theme) => theme.spacing(2) }}
      >
        <Grid
          container
          size={{ xs: 12, lg: 9 }}
        >
          {data.map((card, index) => (
            <Grid key={index} size={{ xs: 6, sm: 6, lg: 4 }}>
              <StatCard card={card} />
            </Grid>
          ))}
          <Grid size={{ xs: 12, lg: 12 }}>
            <Typography component="h2" variant="h6" sx={{ mb: 2 }}>
              Fleets
            </Typography>
            <FleetsDataGrid />
          </Grid>
        </Grid>
        <Grid size={{ xs: 12, lg: 3 }}>
          <Stack gap={2} direction={{ xs: 'column', sm: 'row', lg: 'column' }}>
            <HighlightedCard sx={{ height: '180px' }} />
            <ChartFleetsByType />
          </Stack>
        </Grid>
      </Grid>
      <Copyright sx={{ my: 4 }} />
    </Box>
  );
}
